module.exports = __webpack_public_path__ + "static/logo-3e10f740b032ee5c3c2b13e2a911affd.png";